export default {"src":"/_next/static/media/how-to.a91f8308.svg","height":14,"width":14};